import { cn } from "~/utils/shadecn"

// SFW visibility policy
// ---------------------
// Two-tier gate:
//   1. Must be logged in to see any unblurred content (SFW or not).
//   2. Must be payment-verified (age-verified) to see NSFW content.
//
// Stars/videos flagged SFW are unblurred for logged-in users regardless of
// payment verification. NSFW content requires payment verification.
//
// Network-level privacy: handled by `gateStillsToUser` in
// app/models/videos.server.ts — strips Stills URLs from anon payloads entirely,
// and for logged-in-but-not-payment-verified users returns only SFW-tagged stills.
//
// Visual blur strategy:
//   - Avatars: CSS blur-lg only.
//   - Video stills (VideoCard): pre-blurred BlurredStill + CSS blur-lg layered on top.
//     See workers.server.ts for server-side blur details.

export function shouldBlurAvatar(loggedIn?: boolean, isPaymentVerified?: boolean, isSFW?: boolean) {
  return !loggedIn || (!isPaymentVerified && !isSFW)
}

export function avatarImageClassName(loggedIn?: boolean, isPaymentVerified?: boolean, isSFW?: boolean, baseClassName = "object-cover") {
  return cn(baseClassName, shouldBlurAvatar(loggedIn, isPaymentVerified, isSFW) && "blur-lg")
}

export function shouldUseBlurredStill(loggedIn?: boolean, isPaymentVerified?: boolean, sfwStills?: boolean) {
  return !loggedIn || (!isPaymentVerified && !sfwStills)
}
